import { defineStore } from 'pinia';

export const filterCardapio = defineStore('filterCardapio', {
  state: () => ({
    codConcessionaria: 0
  }),
  actions: {    
    setcodConcessionaria(codConcessionaria : number) {
      this.codConcessionaria = codConcessionaria   
    }
  },
  getters: {
    getCodConcessionaria: (state) => state.codConcessionaria,
   
  },
});

